export default [
  {
    name: 'not_covers.item_1.title',
    description: 'not_covers.item_1.desc'
  },
  {
    name: 'not_covers.item_2.title',
    description: 'not_covers.item_2.desc'
  }
]